import React from 'react';
import { observer } from 'mobx-react';
import noSuggestionFound from 'Assets/png/noSuggestionFound.png';

let renderListFun;
const InputBoxWithSuggestionSingleSelect = observer(props => {
  const {
    inputVal,
    placeholder,
    setInputVal,
    suggestionList,
    noMatchFound,
    handleOnSelect,
    suggestionKey,
    filterInPage,
    isSuggestionLoading = false,
  } = props;

  const boxId = `${suggestionKey}-select`;

  const [showSuggestion, setShowSuggestion] = React.useState(false);

  const onInputChange = e => {
    if (!showSuggestion) setShowSuggestion(true);

    const inpVal = e.currentTarget.value;
    const selector = `.suggestion-list.${boxId} .suggestion-list-wrap`;
    if (document.querySelectorAll(selector).length)
      document.querySelectorAll(selector)[0].scrollTo(0, 0);

    setInputVal(inpVal);
  };

  const submitAction = e => {
    // if (e && e.charCode === 13)
    // Handle enter key press
  };
  const closeSuggestion = () => {
    setShowSuggestion(false);
  };

  renderListFun = () => {
    return suggestionList.map((item, index) => {
      const { displayName, code } = item;
      return (
        <div
          key={suggestionKey + index}
          className="suggestion-item"
          data-index={index}
          data-name={code}
          onClick={e => handleOnSelect(item)}
        >
          <span>{displayName}</span>
        </div>
      );
    });
  };

  const NoMatchFoundComponent = () => {
    return (
      <div className="no-match-found">
        <img src={noSuggestionFound} alt="No suggestion found" />
        No results found
      </div>
    );
  };

  return (
    <>
      <div
        className={`input-section ${showSuggestion ? 'input-focused' : ''}${
          filterInPage ? ' page-suggestion' : ' popup-suggestion'
        }  ${suggestionKey}-filter`}
      >
        <span>
          <input
            className="input-box"
            value={inputVal}
            type="text"
            placeholder={placeholder}
            onChange={onInputChange}
            id={boxId}
            onKeyPress={submitAction}
            autoComplete="new-password"
          />
          <span className="focus-border" />
          {isSuggestionLoading && (
            <span className="loading-wrapper">
              <span className="load-text" />
            </span>
          )}
        </span>
        <div
          className={`suggestion-list ${boxId} animatedFast ${
            showSuggestion ? '' : 'hide-suggestion'
          } ${
            suggestionList.length > 0 || noMatchFound ? 'box-design-shadow' : ''
          }`}
        >
          {(suggestionList.length > 0 || noMatchFound) && (
            <>
              {noMatchFound ? (
                <div className="suggestion-list-wrap">
                  <NoMatchFoundComponent />
                </div>
              ) : (
                <div className="suggestion-list-wrap">{renderListFun()}</div>
              )}
            </>
          )}
        </div>
        {showSuggestion &&
          (suggestionList.length > 0 || noMatchFound || inputVal === '') && (
            <div className="suggestion-mask" onClick={closeSuggestion} />
          )}
      </div>
    </>
  );
});

export { InputBoxWithSuggestionSingleSelect };
export default InputBoxWithSuggestionSingleSelect;
